import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  BaseFormItem,
  BaseInput,
  BaseTextContent,
  BaseTextTitle,
  BaseForm
} from 'xrk-components';
import { IndividualInfoDetailData } from '../../data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'bank',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const formData = _useModel<IndividualInfoDetailData>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BaseTextTitle), null, {
      default: _withCtx(() => [
        _createTextVNode("银行信息")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseForm), {
          "label-position": "top",
          disabled: "",
          model: formData.value,
          "column-count": 4
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              label: "开户银行",
              prop: "operator",
              rules: [
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  type: "text",
                  placeholder: "请输入",
                  modelValue: formData.value.bankInfo,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.bankInfo) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "开户名",
              prop: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  type: "text",
                  placeholder: "请输入",
                  value: ""
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "银行账号",
              prop: "bankCardNum",
              rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  type: "text",
                  placeholder: "请输入",
                  clearable: "",
                  modelValue: formData.value.bankCardNum,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.bankCardNum) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ], 64))
}
}

})